module.exports = {
      id: "clean-map-small-usage",
      viewBox: "0 0 348 202",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#clean-map-small",
      toString: function () {
        return this.url;
      }
    }